import SubscribeForm from '../subscribeForm/SubscribeForm';
import { SubscribeTitle } from './components/SubscribeTitle';

interface SubscribeContentProps {
  textColor: string;
  buttonColor: string;
  buttonTextColor: string;
  // a sikeres feliratkozás állapotát állítja
  setSuccess: (value: boolean) => void;
}

export const SubscribeContent = ({ textColor, buttonColor, buttonTextColor, setSuccess }: SubscribeContentProps) => {
  //@ts-ignore
  const isAdmin = window.isAdminPage;

  const subscribeImageUrl = isAdmin ? '/images/newsletter.png' : '/static_assets/newsletter.png';

  return (
    <>
      <div className='flex flex-col min-[350px]:w-full lg:w-[70%]'>
        <SubscribeTitle textColor={textColor} />
        <SubscribeForm textColor={textColor} buttonColor={buttonColor} buttonTextColor={buttonTextColor} setSuccess={setSuccess} />
      </div>
      <div className='w-[30%] min-[350px]:hidden lg:flex'>
        <img className='m-auto w-[190px] h-[190px] rounded' src={subscribeImageUrl} alt='subscribeImage' />
      </div>
    </>
  );
};
